import api from "./axios";
import type { Scraper, ScraperStats } from "@/types";

export const getAll = () => api.get<Scraper[]>("/scrapers").then((r) => r.data);

export const getOne = (id: string) =>
  api.get<Scraper>(`/scrapers/${id}`).then((r) => r.data);

export const create = (data: Partial<Scraper>) =>
  api.post<Scraper>("/scrapers", data).then((r) => r.data);

export const update = (id: string, data: Partial<Scraper>) =>
  api.patch<Scraper>(`/scrapers/${id}`, data).then((r) => r.data);

export const remove = (id: string) =>
  api.delete(`/scrapers/${id}`).then((r) => r.data);

export const runScraper = (id: string) =>
  api.post(`/scrapers/${id}/run`).then((r) => r.data);

export const getStats = () =>
  api.get<ScraperStats>("/scrapers/stats").then((r) => r.data);
